import AllAdminPrivateProjectsContent from "../../Component/AllAdminPrivateProjects/AllAdminPrivateProjects";

function AllAdminPrivateProject() {
  return <AllAdminPrivateProjectsContent />
     
}

export default AllAdminPrivateProject;
